import React from 'react';
import './Tab.css';

function Tab({ activeTab, changeTabHandler, tabLabel, tabId, count }) {
    const isActive = activeTab === tabId;

    return (
        <button
            className={`profile-tab-btn${isActive ? ' profile-tab-btn--active' : ''}`}
            onClick={() => changeTabHandler(tabId)}
        >
            <span className='profile-tab-label'>{tabLabel}</span>
            {count > 0 && (
                <span className={`profile-tab-badge${isActive ? ' profile-tab-badge--active' : ''}`}>
                    {count}
                </span>
            )}
        </button>
    );
}

export default Tab;
